import type WebSocket from 'ws';
import type { ChildProcess } from 'node:child_process';
import { sendPreviewEnvironmentManagerStatus } from '../state.js';
import type { PreviewEnvironmentManagerState } from '../state.js';
import type { StreamTail } from '../stream-tail.js';

const BRIDGE_TAIL_BROADCAST_MS = 1000;

export function createBridgeTailBroadcastScheduler(options: {
  state: PreviewEnvironmentManagerState;
  getWs: () => WebSocket | null;
  environmentId: string;
  scheduledGen: number;
  proc: ChildProcess;
  stdoutTail: StreamTail;
  stderrTail: StreamTail;
}): () => void {
  const { state, getWs, environmentId, scheduledGen, proc, stdoutTail, stderrTail } = options;
  const timerState = { timer: null as ReturnType<typeof setTimeout> | null };

  return () => {
    if (timerState.timer) return;
    timerState.timer = setTimeout(() => {
      timerState.timer = null;
      if ((state.spawnGenerationByServerId.get(environmentId) ?? 0) !== scheduledGen) return;
      if (!state.processes.has(environmentId)) return;
      sendPreviewEnvironmentManagerStatus(getWs, environmentId, 'running', `pid=${proc.pid ?? '?'}`, {
        stdout: stdoutTail.getTail(),
        stderr: stderrTail.getTail(),
      });
    }, BRIDGE_TAIL_BROADCAST_MS);
  };
}
